import SideMenu from "./SideMenu";
import { baseItemStyle as SideMenuItemBaseStyle } from "./SideMenu.styles";
export { SideMenu, SideMenuItemBaseStyle };
//# sourceMappingURL=index.js.map